import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import CameraModalComponent from './camera.jsx';
import ModalVideoManager from '../../../../lib/video/modal-video-manager-login.js';

import PubSub from 'pubsub-js';
import {faceEnterLibraryRequest} from "../../../../service/user";
import {
    ali_accessKeyId,
    ali_accessKeySecret,
    ali_bucket,
    ali_region,
    ali_tmpimg_path,
} from '../../../../util/constants.js';
import OSS from 'ali-oss';
import {ali_header_url, API_URL,FILE_URL} from "../../../../util/constants";
let client = new OSS({
    accessKeyId: ali_accessKeyId,
    accessKeySecret: ali_accessKeySecret,
    bucket: ali_bucket,
    region: ali_region
});

class CameraModalLogin extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleAccess',
            'handleBack',
            'handleCancel',
            'handleCapture',
            'handleLoaded',
            'handleSubmit',
            'setCanvas',
            'close',
            'isChinese',
            'showToast',
            'faceEnterLibrary'
        ]);

        this.video = null;
        this.videoDevice = null;

        this.state = {
            capture: null,
            access: true,
            loaded: true,
            shibieStatus:false
        };
        PubSub.unsubscribe('takeSnapshot');
        PubSub.subscribe('takeSnapshot', (event, data) => {
            console.log(data);

            var teacherphone = sessionStorage.getItem('teacherphone');
            this.handleCapture(teacherphone);
        });

        PubSub.subscribe('cameraClose', (event, data) => {
            console.log(data);
            if (this.videoDevice) {
                this.videoDevice.disableVideo();
            }
            this.video = null;
            this.videoDevice = null;
        });
    }

    showToast(msg,duration){
        duration=isNaN(duration)?3000:duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText="min-width:180px; background:#000;font-size:16px; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:99999999;";
        document.body.appendChild(m);
        setTimeout(function() {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() { document.body.removeChild(m) }, d * 1000);
        }, duration);
    }


    close () {
        // this.handleCapture();
        // this.props.onClose();
    }

    isChinese(temp)
    {
        var re=/[^\u4e00-\u9fa5]/;
        if(re.test(temp)) return false;
        return true;
    }


    componentWillUnmount () {
        if (this.videoDevice) {
            this.videoDevice.disableVideo();
        }
        this.video = null;
        this.videoDevice = null;

    }

    handleAccess () {
        this.setState({access: true});
    }

    handleLoaded () {
        this.setState({loaded: true});
    }

    handleBack () {
        this.setState({capture: null});
        this.videoDevice.clearSnapshot();
    }

    handleCapture (username) {

            const capture = this.videoDevice.takeSnapshot2();
            this.setState({capture: capture});

            this.props.uploadImgToAlioss(capture);

            //this.handleUpload(username,capture);

    }

    setCanvas (canvas) {
        this.canvas = canvas;
        if (this.canvas) {
            this.videoDevice = new ModalVideoManager(this.canvas);
            this.videoDevice.enableVideo(this.handleAccess, this.handleLoaded);
        }
    }

    handleSubmit () {
        // if (!this.state.capture) return;
        // this.props.onNewCostume(this.state.capture);
        // this.props.onClose();
    }

    handleCancel () {
        this.props.onClose();
    }

    handleUpload (username,imageBase64) {

        var that = this;
        var pngFileName = `${(new Date()).getTime() + Math.floor(Math.random() * (900) + 100)}.png`;
        var pngFilePath = `${ali_tmpimg_path}${pngFileName}`;
        var imgBlob = this.dataURLtoFile(imageBase64);

        var imgUrl = ali_header_url + pngFilePath;

        client.put(pngFilePath, imgBlob)
            .then(function (r1) {
                console.log('ali uplload', r1);

                that.props.takeSnapshotSuccess(imgUrl);

                //that.faceEnterLibrary(imgUrl);
            })

            .catch(function (err) {
                console.error('error: %j', err);
                that.showToast('采集失败',1000);
            });


    }

    dataURLtoFile (dataurl, filename = 'file') {
        let arr = dataurl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let suffix = mime.split('/')[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], `${filename}.${suffix}`, {type: mime})
    }

    faceEnterLibrary(imgurl){
        var that = this;
        faceEnterLibraryRequest(imgurl, (data) => {
            console.log(data);

            if(data.ret=='1'){

                PubSub.publish('loginByFaceSuccess','');


            }else {
               that.showToast(data.msg,1000);
            }

        });

    }

    render () {
        return (
            <CameraModalComponent
                access={this.state.access}
                canvasRef={this.setCanvas}
                capture={this.state.capture}
                loaded={this.state.loaded}
                onBack={this.handleBack}
                onCancel={this.handleCancel}
                onCapture={this.handleCapture}
                onSubmit={this.handleSubmit}
                shibieStatus={this.state.shibieStatus}
            />
        );
    }
}

CameraModalLogin.propTypes = {
    onClose: PropTypes.func,

};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    // onClose: () => {
    //     dispatch(closeCameraModal());
    // }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CameraModalLogin);
